import api from "./axiosInterceptor";

export const getIndustryDetails = (postData = {}) =>
  api.get(`/scenario/api/industry-data`, {
    params: postData,
  });
